import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./context/AuthContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { CheckoutProvider } from "./context/CheckoutContext";

const clientId = "533923124212-d3us5eaulrpf5s8dkudlpdoterfobfn0.apps.googleusercontent.com"; 

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
      <GoogleOAuthProvider clientId={clientId}>
    <AuthProvider>
      <CheckoutProvider>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  </CheckoutProvider>
      </AuthProvider>
      </GoogleOAuthProvider>
  </React.StrictMode>
);